import { isAfter, isBefore } from 'date-fns'

import { EMPTY_OBJECT } from '../../../constants/common'
import {
  NEWSBOARD_POST_STATUS_BLOCKED,
  NEWSBOARD_POST_STATUS_OFFLINE,
  NEWSBOARD_POST_STATUS_ONLINE,
  NEWSBOARD_POST_STATUS_PLANNED,
} from '../../../constants/newsboard'
import { isValueStringType } from '../../../utils/common'
import { isTvTickerPostType } from '../Newsboard.utils'

// The post-list API returns a computed `status`, but the detail endpoint does
// not — derive the same online/planned/offline/blocked value from `spam` and
// the visibility window so the profile header shows the status chip too.
function getNewsboardPostStatus({ date_from, date_to, spam, status }) {
  if (status) {
    return status
  }

  if (spam) {
    return NEWSBOARD_POST_STATUS_BLOCKED
  }

  const now = new Date()

  if (date_from && isAfter(new Date(date_from), now)) {
    return NEWSBOARD_POST_STATUS_PLANNED
  }

  if (date_to && isBefore(new Date(date_to), now)) {
    return NEWSBOARD_POST_STATUS_OFFLINE
  }

  return NEWSBOARD_POST_STATUS_ONLINE
}

export function getNewsboardPostProfilePreparedData(data) {
  const permissions = data?.permissions || EMPTY_OBJECT
  const canToggleLike = permissions.can_like || permissions.can_like_or_dislike

  return data
    ? {
        ...data,
        counters: {
          comments: data.comment_count ?? 0,
          likes: data.like_count ?? 0,
          viewers: data.views_counter ?? 0,
        },
        isTvTicker: isTvTickerPostType(data),
        permissions: {
          ...permissions,
          can_like_post: permissions.can_like_post ?? canToggleLike,
          can_unlike_post: permissions.can_unlike_post ?? canToggleLike,
        },
        post_type: isValueStringType(data.post_type)
          ? { title: data.post_type }
          : data.post_type,
        status: getNewsboardPostStatus(data),
      }
    : null
}
